import { graphql } from "gatsby"
import React from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"

import Card from "@knowit-alma/common/src/components/molecules/Card/Card"
import ContactCard from "@knowit-alma/common/src/components/molecules/ContactCard/ContactCard"

const ContactCardBlock = ({ blockDataContactCards }) => {
  const { contact } = blockDataContactCards || {}

  let block = ""

  if (contact) {
    if (contact.length === 1) {
      const personMeta = contact[0].personMeta

      block = (
        <ContactCard
          name={personMeta.name}
          text={personMeta.jobtitle}
          phone={personMeta.phonenumber}
          email={personMeta.email}
          image={personMeta.image}
        />
      )
    }

    if (contact.length > 1) {
      const items = contact
        .map((item, index) => {
          const { name, jobtitle, phonenumber, email, image } = item.personMeta
          return (
            <Col key={index} md="4">
              <Card
                headingSize="h2"
                image={image ? image : false}
                imageAspectRatio={"16:9"}
                title={name}
                subtitle={jobtitle}
                list={[
                  phonenumber,
                  email ? <a href={`mailto:${email}`}>{email}</a> : null,
                ]}
                placeholder={true}
              />
            </Col>
          )
        })
        .filter(Boolean)

      block = <Row className="mobile-bottom-margins">{items}</Row>
    }
  }

  return (
    <section className="block-follows-heading base-margin-top-large base-margin-bottom-large">
      {block}
    </section>
  )
}
export const query = graphql`
  fragment ContactCards on WpBlockAcfContactCards {
    __typename
    blockDataContactCards {
      contact {
        ... on WpPerson {
          personMeta {
            name
            email
            jobtitle
            phonenumber
            image {
              mediaDetails {
                width
                height
              }
              sourceUrl
              altText
              altTextOriginal
            }
          }
        }
      }
    }
  }
`

export default ContactCardBlock
